module.exports = __webpack_public_path__ + "img/elipse-2.e199b887.svg";